define([], function passwordModalStateModule() {
  'use strict';

  var state = function state() {
    var NAMESPACE = 'passwordModal';
    var ALIAS = 'passwordModal';

    var mutations = {
      init: function init() {
        return {
          errorCode: 0,
          gotoMarketing: false
        };
      },
      update: function update(_moduleState, _payload) {
        return Object.assign({}, _moduleState, _payload);
      },
      error: function error(_moduleState, _payload) {
        return Object.assign({}, _moduleState, {errorCode: _payload});
      }
    };

    return {
      namespace: NAMESPACE,
      alias: ALIAS,
      mutations: mutations
    };
  };
  return state;
});
